import './Design12.css';

function Design12() {
  return (
    <section className="features12-section">
      <div className="features12-content">
        <div className="features12-left">
          <div className="features12-label">
            <span className="features12-asterisk">*</span> KEY BENEFITS
          </div>
          <h1 className="features12-title">
         Discover the <span className="highlight12">benefits</span> of<br />
choosing us today          </h1>
        </div>
        <div className="features12-right">
          <p className="features12-desc">
Experience unparalleled creativity, data-driven strategies, and dedicated support that drive real results for your brand.          </p>
          {/* <div className="features12-cta-row">
            <button className="features12-btn">
              Learn More
            </button>
            <span className="features12-btn-icon" aria-label="arrow up right">↗</span>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Design12;
